import {TAppThunk} from 'core/redux/types';
import {GoogleAnalyticsService} from 'modules/google-analytics/service';

export const loadGAScript = (): TAppThunk<void> => async () => {
    try {
        await GoogleAnalyticsService.gtmConnectScript();
    } catch (e) {
        console.error(e);
    }
};
